import { render, staticRenderFns } from "./FormCalculatorBodyPart.vue?vue&type=template&id=2687d1a0&scoped=true&"
import script from "./FormCalculatorBodyPart.vue?vue&type=script&lang=js&"
export * from "./FormCalculatorBodyPart.vue?vue&type=script&lang=js&"
import style0 from "./FormCalculatorBodyPart.vue?vue&type=style&index=0&id=2687d1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687d1a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VRow,VSlider,VSubheader})
